import { Icon, IIconProps } from "native-base";
import * as React from "react";
import { Path } from "react-native-svg";

export const WhatsappColoured = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22c-1.818 0-3.636-.458-5.152-1.374l-.303-.153-3.787 1.069 1.06-3.664-.303-.458C2.455 15.74 2 13.908 2 12.076 2 6.58 6.545 2 12 2c2.727 0 5.151 1.069 7.121 2.9C21.091 6.887 22 9.329 22 12.077 22 17.42 17.606 22 12 22Zm5.455-7.634c.047.024.094.044.14.064.253.108.49.208.617.852.152 0 .152.611-.151 1.375-.152.61-1.364 1.373-1.97 1.373-.103 0-.201.01-.306.019-.515.046-1.191.106-3.33-.782-2.656-1.07-4.497-3.664-5.014-4.393-.073-.102-.12-.168-.138-.187-.026-.052-.078-.135-.147-.244-.335-.534-1.065-1.695-1.065-2.962 0-1.527.757-2.29 1.06-2.595.304-.306.607-.306.758-.306h.606c.152 0 .455 0 .606.458.303.61.91 2.138.91 2.29 0 .051.016.102.033.153.034.102.067.203-.034.305a.8.8 0 0 0-.151.23.8.8 0 0 1-.152.228l-.454.458c-.152.153-.303.306-.152.611.152.305.758 1.374 1.667 2.137 1.023.902 1.83 1.26 2.239 1.442.076.034.138.061.185.085.303 0 .455 0 .606-.153.076-.152.265-.381.455-.61.19-.23.379-.458.454-.61.152-.306.303-.306.606-.154.303 0 1.818.764 2.122.916Z"
        fill="#64B161"
      />
    </Icon>
  );
};

export default WhatsappColoured;
